import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import {
  blueGreyMui,
  blueMui,
  deepPurpleMui,
  greyMui,
  orangeMui,
} from "@ryde/theme";

export const RebuildRouteDropdownMenu = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "rebuild-route-dropdown-menu",
  className: "rebuild-route-dropdown-menu",
})`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 4px;
  min-width: 420px;
  max-width: 480px;

  .rebuild-route-dropdown-plate {
    border-radius: 10px;
    border: 1px solid ${greyMui._200};
    padding: 10px 10px 8px;
    margin: 0 10px;
    background-color: ${greyMui._50};
  }

  .rebuild-route-dropdown-plate--info {
    background-color: ${blueGreyMui._50};
    border-color: ${blueGreyMui._100};
    padding: 8px 8px 8px 12px;
  }

  .rebuild-route-dropdown-plate--default {
    background-color: ${deepPurpleMui._50};
    border-color: ${deepPurpleMui._100};
  }

  .rebuild-route-dropdown-default-rebuild-heading,
  .rebuild-route-dropdown-custom-rebuild-heading {
    margin: 4px 10px -4px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.3;
    color: ${greyMui._700};
  }

  .rebuild-route-dropdown-plate--providers {
    padding-bottom: 6px;
  }

  .rebuild-route-dropdown-providers {
    .MuiFormControlLabel-root {
      margin: 1px 0;
      color: ${greyMui._900};
    }
  }

  .rebuild-route-provider-label {
    display: inline-flex;
    align-items: center;
    gap: 2px;
  }

  .rebuild-route-dropdown-plate--options {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .rebuild-route-dropdown-applied {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.4;
    color: ${blueGreyMui._800};
  }

  .rebuild-route-dropdown-applied-label {
    min-width: 0;
  }

  .rebuild-route-dropdown-applied-ml-path {
    flex-shrink: 0;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.3;
    color: ${greyMui._500};
    cursor: pointer;
    white-space: nowrap;

    &:hover {
      color: ${greyMui._700};
      text-decoration: underline;
    }

    &:focus-visible {
      outline: 2px solid ${deepPurpleMui.A400};
      outline-offset: 2px;
    }
  }

  .rebuild-route-dropdown-close {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    margin: 0;
    padding: 0;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: ${greyMui._600};
    font-size: 18px;
    line-height: 1;
    cursor: pointer;

    &:hover {
      background-color: ${greyMui._100};
      color: ${greyMui._800};
    }

    &:focus-visible {
      outline: 2px solid ${deepPurpleMui.A400};
      outline-offset: 1px;
    }
  }

  .rebuild-route-dropdown-settings {
    padding: 2px 2px 8px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.4;
    color: ${greyMui._600};
  }

  .rebuild-route-dropdown-settings--inline {
    padding: 0;
  }

  .rebuild-route-dropdown-default-provider-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 0 2px 8px;
  }

  .rebuild-route-dropdown-default-provider-row--after-submit {
    padding: 8px 2px 0;
  }

  .rebuild-route-dropdown-reset-badge {
    flex-shrink: 0;
    border: 1px solid ${deepPurpleMui._200};
    border-radius: 999px;
    background-color: #ffffff;
    color: ${deepPurpleMui._700};
    font-size: 10px;
    font-weight: 700;
    line-height: 1.2;
    padding: 4px 8px;
    cursor: pointer;
    white-space: nowrap;

    &:hover:not(:disabled) {
      background-color: ${deepPurpleMui._50};
    }

    &:disabled {
      cursor: default;
      opacity: 0.6;
    }

    &:focus-visible {
      outline: 2px solid ${deepPurpleMui.A400};
      outline-offset: 2px;
    }
  }

  .rebuild-route-dropdown-submit {
    width: 100%;
    text-transform: none;
    white-space: normal;
    line-height: 1.3;
    border-radius: 8px;
    font-weight: 600;
    padding: 8px 12px;
    box-shadow: none;

    &:focus-visible {
      outline: 2px solid ${deepPurpleMui.A400};
      outline-offset: 2px;
    }

    .MuiButton-startIcon {
      margin-inline-end: 8px;
      align-self: flex-start;
      margin-top: 2px;
    }

    .MuiButton-label {
      width: 100%;
      justify-content: flex-start;
      white-space: normal;
      text-align: start;
    }
  }

  .rebuild-route-dropdown-submit-tooltip-anchor {
    display: block;
    width: 100%;
  }

  .rebuild-route-dropdown-submit-copy {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    text-align: start;
  }

  .rebuild-route-dropdown-submit-title {
    font-size: 13px;
    font-weight: 700;
    line-height: 1.25;
  }

  .rebuild-route-dropdown-submit-hint {
    font-size: 11px;
    font-weight: 600;
    line-height: 1.3;
    opacity: 0.82;
  }

  .rebuild-route-dropdown-avoid-tolls-row {
    display: flex;
    align-items: center;
    margin-block: 0 4px;

    .rebuild-route-dropdown-option-item {
      margin: 0;
    }
  }

  .rebuild-route-dropdown-avoid-tolls-label {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .rebuild-route-dropdown-avoid-tolls-badge {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    border-radius: 999px;
    font-size: 10px;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: 0.02em;
    padding: 2px 7px;
    white-space: nowrap;
    cursor: help;

    &:focus-visible {
      outline: 2px solid ${deepPurpleMui.A400};
      outline-offset: 2px;
    }
  }

  .rebuild-route-dropdown-avoid-tolls-badge--matches {
    color: ${blueMui._800};
    background-color: ${blueMui._50};
    border: 1px solid ${blueMui._200};
  }

  .rebuild-route-dropdown-avoid-tolls-badge--mismatch {
    color: ${orangeMui._800};
    background-color: ${orangeMui._50};
    border: 1px solid ${orangeMui._200};
  }

  .rebuild-route-dropdown-submit--secondary {
    background-color: #ffffff;
    color: ${deepPurpleMui._700};
    border: 1px solid ${deepPurpleMui._200};

    &:hover {
      background-color: ${deepPurpleMui._50};
    }
  }

  .rebuild-route-dropdown-submit--skip-cache-active {
    background-color: ${deepPurpleMui._600};
    color: #ffffff;
    border-color: ${deepPurpleMui._600};

    &:hover {
      background-color: ${deepPurpleMui._700};
      border-color: ${deepPurpleMui._700};
    }
  }

  .rebuild-route-dropdown-skip-cache-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-block: 0 4px;
  }

  .rebuild-route-dropdown-radio-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;

    .rebuild-route-dropdown-radio-item {
      flex: 1;
      min-width: 0;
      margin: 1px 0;
    }
  }

  .rebuild-route-dropdown-option-item.rebuild-route-dropdown-default-action-checkbox {
    flex: 1;
    min-width: 0;
    padding-inline-start: 0;
    margin-inline-start: 1px;
    margin-block: 0;

    .MuiFormControlLabel-label {
      font-size: 13px;
    }
  }

  .rebuild-route-dropdown-skip-cache-info {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: transparent;
    color: ${greyMui._500};
    font-size: 16px;
    cursor: help;

    &:hover {
      color: ${deepPurpleMui._600};
      background-color: ${deepPurpleMui._50};
    }

    &:focus-visible {
      outline: 2px solid ${deepPurpleMui.A400};
      outline-offset: 2px;
    }
  }
`;
